import { Outlet } from "react-router";
import AdminSlider from "../components/admin/admin-slider";
import { useEffect } from "react";
import userStore from "../providers/user-provider";

const AdminLayout = () => {
    useEffect(()=>{
        userStore.handleGteUserDetail();
    },[])
    return <div className="w-screen h-screen flex bg-background dark:bg-dark-background overflow-hidden">
        <div className="h-full">
            <AdminSlider />
        </div>
        <div className="flex-1 p-4">
            <div className="w-full h-full rounded-md shadow-md bg-white dark:bg-black dark:shadow-info/50">
                <Outlet />
            </div>
        </div>
    </div>
}

export default AdminLayout;